// extracted by mini-css-extract-plugin
export default {"input":"InputCell_input__haisb"};